import { AbstractEditService } from '@/core/services/edit.service'
import { AbstractListService } from '@/core/services/list.service'
import { AbstractSearchService } from '@/core/services/search.service'
import Crypto from 'crypto-js'
import { reactive } from 'vue'
import { AppConfig } from './types'

class List extends AbstractListService<Store> {
  size = 20
  getFetchURL(): string {
    return 'template_app/list'
  }
  getSearchParams(): any {
    return this.context.search.getSearchParams()
  }
}

class Edit extends AbstractEditService<Store> {
  getFetchURL(): string | boolean {
    return false
  }
  getDefaultFormData() {
    return {
      appName: '',
      icon: '',
      url: '',
      labels: [],
      operation: [],
      showOrientationSwitch: false,
      orientation: 'portrait',
      contrast: 120,
      dpi: 150,
      showScaleSwitch: false,
      scale: 100,
      showPageTurner: false,
      openNewWindow: false,
      cookies: false,
      initScript: '',
      ratio_width: 0,
      ratio_height: 0,
      special_ua: ''
    } as AppConfig
  }
  parseFetchedFormData(data: any) {
    return {
      ...data,
      initScript: aes.decode(data.initScript || '')
    } as AppConfig
  }
  getRemoveURL(): string {
    return `template_app/${this.params.id}`
  }
  getSubmitURL(): string {
    return this.isEdit ? `template_app/${this.data.id}` : 'template_app'
  }
  getSubmitData() {
    return {
      ...this.data,
      initScript: aes.encode(this.data.initScript)
    }
  }
  requestListReload(option?): void {
    this.context.list.fetch(option)
  }
}

class Search extends AbstractSearchService {
  onSubmit(): void {
    this.context.list.fetch({ reset: true })
  }
}

class Store {
  search: Search
  list: List
  edit: Edit
  constructor() {
    this.search = new Search(this)
    this.list = new List(this)
    this.edit = new Edit(this)
  }
}

export const store = reactive(new Store())

export const aes = {
  encode: (str: string): string => {
    return Crypto.AES.encrypt(str, '1234567890abcdef').toString()
  },
  decode: (str: string): string => {
    return Crypto.AES.decrypt(str, '1234567890abcdef').toString(Crypto.enc.Utf8)
  }
}
